import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, Image
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import AdapterListOperatorApply from "./adapters/AdapterListOperatorApply";
import store from "../../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError
} from "./action/ActionListOperatorApplysScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import HMTextInput from "../../../../customviews/HMTextInput";
//import HMModal from "../../../../customviews/HMModal";
import * as NavigationService from "../../../../redux/NavigationService";
import HMButton from "../../../../customviews/HMButton";
import HMIcon from "../../../../customviews/HMIcon";
import HMModalSearch from "../../../../customviews/HMModalSearch";

import importFirebase from "../../../../importCalss/firebase/importFirebase";
import {Tools} from "../../../../tools/Tools";
import PathFile from "../../../../assets/PathFile";

let firebase = importFirebase;

let container = null;

export default class ListOperatorApplyScreen extends Component {
    constructor(props) {
        super(props);
        //global._refreshListOpertor = true;
        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }

        if (Platform.OS === "android") {

            //firebase = require("react-native-firebase")
            // alert(firebase)

        }
        this.state = {

            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            //  textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,
            checkBoxMyWork: false,

            /* dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                 name: 'در دست اقدام',
                 id: 2
             }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                 name: 'تایید واحد',
                 id: 5
             },],
             textCondition: null,
             arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                 name: 'تکراری در دست اقدام',
                 id: 3
             }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],*/
            Condition: {id: 0, value: "وضعیت پیام"},

            // arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            //   dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null

        };
        container = this;


    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {
        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {

                    Tools.goDetailsOpenNotif()

                }
            )
            :
            null
    }

    /*    async componentDidMount() {

            const channel = new firebase.notifications.Android.Channel(
                'channelId',
                'Channel Name',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }

                if (notification && notification.data && notification.data.typeOperation === '1') {
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });
        }*/

    async componentDidMount() {
        let checkGetData = true;
        this.props.navigation.addListener('focus', () => {
                if (global._refreshListOpertor) {
                    checkGetData = false;

                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                    global._refreshListOpertor = false
                }

            }
        )
        this.props.navigation.addListener('blur', () => {
            }
        )

        if (checkGetData === true) {
            store.dispatch(serviceActionListFilter([]))
            this.props.callserviceActionRefresh();
            this.getData(1)
        }
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })
        // await DeviceInfo.getMacAddress().then(mac => {
        //     //alert(mac)
        //     MAC_ADDRESS = mac
        // });
        // store.dispatch(serviceActionListFilter([]))
        // this.props.callserviceActionRefresh();
        // this.getData(1)


        /*          const channel = new firebase.notifications.Android.Channel(
                      '1',
                      'A',
                      firebase.notifications.Android.Importance.Max
                  ).setDescription('A natural description of the channel');
                  firebase.notifications().android.createChannel(channel);

                  // the listener returns a function you can use to unsubscribe
                  this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                      if (Platform.OS === 'android') {
                          const localNotification = new firebase.notifications.Notification({
                              sound: 'default',
                              show_in_foreground: true,
                          }).setNotificationId(notification.notificationId)
                              .setTitle(notification.title)
                              .setSubtitle(notification.subtitle)
                              .setBody(notification.body)
                              .setData(notification.data)
                              .android.setChannelId('channelId') // e.g. the id you chose above
                              .android.setSmallIcon('logo') // create this icon in Android Studio
                              .android.setLargeIcon('logo') // create this icon in Android Studio

                              //  .android.setColor('#000000') // you can set a color here
                              .android.setPriority(firebase.notifications.Android.Priority.High);

                          firebase.notifications()
                              .displayNotification(localNotification)
                              .catch(err => console.error("error_notifications", err));

                      }
                      else if (Platform.OS === 'ios') {

                          const localNotification = new firebase.notifications.Notification()
                              .setNotificationId(notification.notificationId)
                              .setTitle(notification.title)
                              .setSubtitle(notification.subtitle)
                              .setBody(notification.body)
                              .setData(notification.data)
                              .ios.setBadge(notification.ios.badge);

                          firebase.notifications()
                              .displayNotification(localNotification)
                              .catch(err => console.error(err));
                      }


                      if (notification && notification.data && notification.data.typeOperation === '1') {
                          if (item.length > 0) {
                              global.list_menu_shahrdar = item;
                              this.setState({alaki: !this.state.alaki})

                          }
                          store.dispatch(serviceActionListFilter([]))
                          this.props.callserviceActionRefresh();
                          this.getData(1)
                      }

                  });


                  this.notificationOpenedListener = await firebase.notifications().onNotificationOpened((notificationOpen: NotificationOpen) => {
                      // Get the action triggered by the notification being opened
                      const action = notificationOpen.action;
                      // Get information about the notification that was opened
                      const notification: Notification = notificationOpen.notification;
                      let item = null
                      if (notificationOpen.notification.data.item)
                          item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                      try {
                          firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

                          switch (notificationOpen.notification.data.typeOperation) {
                              //looking for
                              case "1":
                                  if (item) {
                                      // if (this.props.result && this.props.result > 0) {
                                      //     let idx = this.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
                                      //     if (idx === -1) {
                                      //         store.dispatch(serviceActionListFilter([]))
                                      //         this.props.callserviceActionRefresh();
                                      //         this.getData(1)
                                      //     }
                                      //
                                      // }
                                      //  NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                      NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                                          index: 0,
                                          item: item,
                                      })
                                  }

                                  // NavigationService.navigatereset("MessagesBuy", {type: 1});
                                  //NavigationService.navigateParams("MessagesBuy", {type: 2});
                                  break;

                              // case "1":
                              //     // NavigationService.navigatereset("MessagesSell", {type: 2});
                              //     NavigationService.navigateParams("MessagesSell", {type: 1});
                              //     break;
                              default:

                          }

                      }
                      catch (e) {

                      }

                  });
      */
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.refreshData)
        this.notificationOpenedListener = Tools.receiveOnNotificationOpened(this.goScreenClickNotif)


        // let myLocation = store.getState().reducerSplashGetAllData.Location;
        // myLocation ? this.sendLocation(myLocation.coords) : null;

    }

    refreshData() {
        store.dispatch(serviceActionListFilter([]));
        container.props.callserviceActionRefresh();
        container.getData(1);
    }

    goScreenClickNotif(item) {
        /*if (container.props.result && container.props.result > 0) {
            let idx = container.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
            if (idx === -1) {
                container.refreshData()
            }
            else {
                NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                    index: 0,
                    item: item,
                })
            }

        }*/
        NavigationService.navigateParams("DetailsOperatorApplyScreen", {
            index: 0,
            item: item,
        })

    }

    /*   async goDetailsOpenNotif() {
           const notificationOpen = await firebase.notifications().getInitialNotification();
           let item = null

           if (notificationOpen) {
               if (notificationOpen.notification.data.item)
                   item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())
           firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)
               try {
                   switch (notificationOpen.notification.data.typeOperation) {
                       //looking for
                       case "2":
                           if (item)
                               NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                   index: 0,
                                   item: item,
                               })
                           // NavigationService.navigatereset("MessagesBuy", {type: 1});
                           //     NavigationService.navigateParams("MessagesBuy", {type: 2});
                           break;

                       case "1":
                           // NavigationService.navigatereset("MessagesSell", {type: 2});
                           //NavigationService.navigateParams("MessagesSell", {type: 1});
                           break;
                       default:

                   }

               }
               catch (e) {

               }
           }
       }*/

    componentWillUnmount() {
        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
            this.notificationOpenedListener();

        }
    }

    async getData(page) {
        let {item, data, type} = this.props.route.params;
        let itemOrginal = item;
        // item = JSON.parse(item);
        let after = "0000-00-00";
        //   this.props.callService(urlListOperatorApplyScreen, `?type=${this.props.typee}&Condition=`, TypeGetListOperatorApplyScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListOperatorApplyScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListOperatorApplyScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListOperatorApplyScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": item.type == 7 || type == "requestMahalehMa" ? "GetCalendarMahaleh" : typeExport._GetCalendar,
            //  "mode": typeExport._GetCalendar,
            "lang": i18n.locale,
            "token_mahale": this.props.DataSplashScreen.tokenMahaleh,
            "_session": store.getState().reducerSplashGetAllData.token,
            "page": page,
            "type": item.type,
            "extra": itemOrginal,
            "listFilter": this.state.arraySelected,
            "trackingCode": this.state.trackingCode,
            "mode_type": this.state.checkBoxMyWork ? "mine" : "all",

            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        if (store.getState().reducerSplashGetAllData.Connection) {

            this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetListOperatorApplyScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApply + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };


    render() {
        let {item, data, type} = this.props.route.params;
        //    data = JSON.parse(data);
        let {DataSplashScreen} = this.props;

        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            // menu
                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListOperatorApply.title')}
                            //text={i18n.t('ListNews.title')}
                            text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerListOperatorApplyScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>
                            <View
                                style={{
                                    height: moderateScale(42),
                                    backgroundColor: Colors.colorPrimary,
                                    flexDirection: 'row',
                                    marginHorizontal: moderateScale(10),
                                    marginTop: moderateScale(6),
                                    borderRadius: moderateScale(14),
                                    borderColor: Colors.colorDark,
                                    borderWidth: moderateScale(1),
                                    //  marginBottom: moderateScale(10)
                                    // width:'100%'
                                }}>

                                <View
                                    style={{
                                        flex: .8,
                                        height: moderateScale(40),
                                        backgroundColor: Colors.white,
                                        borderRadius: moderateScale(14),
                                        flexDirection: 'row',
                                        paddingHorizontal: moderateScale(4),
                                        alignItems: 'center',

                                    }}>

                                    <View style={{width: moderateScale(5)}}/>

                                    <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                        <HMTextInput value={this.state.trackingCode}
                                                     onChangeText={(text) => this.setState({trackingCode: text}, () => {
                                                         //  this.getJsonMap()

                                                     })}
                                                     _height={40}
                                            //  autoFocus
                                            //  placeholder={i18n.t('constant.filter')}
                                                     placeholder={i18n.t('constant.TrackingCode') + " یا آدرس را جستجو نمایید"}
                                                     NoShowPlaceholder
                                            //باتد_width={'80%'}
                                            // icon={"md-person"}
                                                     style={{
                                                         fontSize: moderateScale(13),

                                                         // marginTop: moderateScale(6)
                                                     }} underlineColorAndroid="transparent"/>
                                    </View>
                                    {/*{*/}
                                    {/*this.state.loadingAddressMarker ?*/}
                                    {/*<ActivityIndicator color={Colors.colorPrimary}*/}
                                    {/*size={"large"}/>*/}

                                    {/*:*/}
                                    {/*<HMTextView*/}
                                    {/*numberOfLines={1}*/}
                                    {/*onPress={() => HMAlert(*/}
                                    {/*i18n.t('constant.address'),*/}
                                    {/*this.state.addressMap,*/}
                                    {/*[*/}
                                    {/*// {text: 'Ask me later', onPress: () => {}},*/}
                                    {/*// {text: 'Cancel', onPress: () => {}, style: 'cancel'},*/}
                                    {/*{*/}
                                    {/*text: i18n.t('constant.ok'), onPress: () => {*/}
                                    {/*}*/}
                                    {/*},*/}
                                    {/*],*/}
                                    {/*{cancelable: true}*/}
                                    {/*)}*/}
                                    {/*//text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}*/}
                                    {/*text={this.state.addressMap}*/}
                                    {/*type={"bold"} style={{*/}
                                    {/*//textAlign: "center",*/}
                                    {/*color: Colors.gray,*/}
                                    {/*fontSize: moderateScale(11),*/}
                                    {/*marginEnd: moderateScale(3)*/}


                                    {/*// flex:1*/}
                                    {/*}}/>*/}
                                    {/*}*/}

                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.getData(1)
                                        //  this.nextScreen(item, type)
                                    }}
                                    style={{
                                        flex: .2,
                                        height: moderateScale(32),
                                        backgroundColor: Colors.colorPrimary,
                                        borderTopEndRadius: moderateScale(14),
                                        borderBottomEndRadius: moderateScale(14),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={i18n.t('constant.Search')}
                                        type={"bold"}
                                        style={{
                                            textAlign: "center",
                                            color: Colors.white,
                                            fontSize: moderateScale(13)

                                        }}/>
                                </TouchableOpacity>

                            </View>
                            <View style={{
                                marginVertical: moderateScale(4),
                                marginHorizontal: moderateScale(12),
                                flexDirection: 'row',
                            }}>
                                {
                                    DataSplashScreen && DataSplashScreen.resultsShahrdar && DataSplashScreen.resultsShahrdar.result && DataSplashScreen.resultsShahrdar.result.info && DataSplashScreen.resultsShahrdar.result.info.myTask ?
                                        <TouchableOpacity
                                            style={{
                                                flexDirection: 'row',
                                                paddingHorizontal: moderateScale(3),
                                                backgroundColor: this.state.checkBoxMyWork ? Colors.colorPrimary : Colors.white,
                                                borderRadius: moderateScale(4),
                                                marginHorizontal: moderateScale(6),
                                                alignItems: 'center',
                                                //justifyContent: 'center',
                                                height: moderateScale(36)
                                            }}
                                            onPress={
                                                () => {
                                                    this.setState({
                                                            checkBoxMyWork: !this.state.checkBoxMyWork
                                                        },
                                                        () => {
                                                            this.getData(1);
                                                        }
                                                    )
                                                    //onPress(item, data.name, check)
                                                }}>
                                            <View style={{
                                                width: moderateScale(24),
                                                height: moderateScale(24),
                                                backgroundColor: '#ffffff',
                                                borderRadius: moderateScale(12),
                                                alignItems: 'center', justifyContent: 'center',
                                                borderWidth: moderateScale(1),
                                                borderColor: Colors.gray

                                            }}>
                                                <Image
                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                    source={PathFile.image.Check}
                                                    //resizeMode="stretch"
                                                    style={[!this.state.checkBoxMyWork ? {
                                                        width: moderateScale(0),
                                                        height: moderateScale(0),
                                                    } : {


                                                        width: moderateScale(18),
                                                        height: moderateScale(18),
                                                    }]}/>
                                            </View>
                                            <HMTextView
                                                //  numberOfLines={1}
                                                // type={'bold'}
                                                text={"وظایف خودم"}
                                                style={{

                                                    color: this.state.checkBoxMyWork ? Colors.white : Colors.colorDarkText,
                                                    // marginEnd: moderateScale(10),
                                                    fontSize: moderateScale(12),
                                                    // textAlign: 'center',
                                                    marginHorizontal: moderateScale(4)

                                                }}/>
                                        </TouchableOpacity>
                                        :
                                        null
                                }


                                <FlatList
                                    // style={{height: moderateScale(36)}}
                                    //    data={result.items}
                                    data={this.props.ListFilter ? this.props.ListFilter : []}
                                    // data={[
                                    //     {
                                    //
                                    //         type: '1',
                                    //         name: 'وضعیت پیام',
                                    //
                                    //     },
                                    //     {
                                    //
                                    //         type: '2',
                                    //         name: 'واحد اجرایی',
                                    //     },
                                    //
                                    //     // {
                                    //     //
                                    //     //     type: '3',
                                    //     //     name: 'تاریخ',
                                    //     // },
                                    //
                                    // ]}
                                    //   numColumns={3}
                                    renderItem={this.renderItemFilter}
                                    horizontal={true}
                                    showsHorizontalScrollIndicator={false}
                                    keyExtractor={(item, index) => index.toString()}
                                    inverted={Platform.OS === 'android' && i18n.locale == 'fa'}


                                />
                            </View>

                            <EmptyView empty={this.props.empty}/>
                            <FlatList
                                data={this.props.results}
                                renderItem={({item, index}) => {
                                    return <AdapterListOperatorApply item={item}
                                                                     resultAll={this.props.resultAll}
                                                                     item_parent={this.props.route.params.item}
                                                                     item_parentPars={data}
                                                                     type={type}
                                                                     index={index} hiddenModal={this.hiddenModal}/>;
                                }}
                                // extraData={[this.props.results]}
                                keyExtractor={(item, index) => index.toString() + (item.lastWork?.length) + item._dateUpdate_O}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                numColumns={this.state.columnCount}
                                key={this.state.columnCount}
                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }

                            <HMModalSearch
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />


                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            {
                <View
                    style={[{
                        //marginVertical: moderateScale(15),
                        height: moderateScale(36),
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row'
                    }]}>
                    {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                    {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                    {
                        checkIndex ?

                            <View style={{flexDirection: 'row'}}>


                                <TouchableOpacity
                                    onPress={() => {
                                        //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                        let arr = container.state.arraySelected;

                                        if (idx !== -1) {
                                            arr.splice(idx, 1)

                                            container.setState({
                                                    arraySelected: arr,
                                                    [`selectFilter${index}`]: {
                                                        value: item.name,
                                                        id: item.id,
                                                        type: item.type
                                                    },
                                                    visibleModal: '',
                                                },

                                                () => {
                                                    container.getData(1)
                                                }
                                            )
                                        }
                                        // container.setState({
                                        //         [`selectFilter${index}`]: {
                                        //             value: item.name,
                                        //             id: item.id,
                                        //             type:item.type
                                        //         },
                                        //         visibleModal: '',
                                        //     },
                                        //     () => {
                                        //         let arr = this.state.arraySelected;
                                        //         this.setState({
                                        //                 arraySelected: arr
                                        //             },
                                        //             () => {
                                        //                 container.getData(1)
                                        //             }
                                        //         )
                                        //
                                        //     }
                                        // )

                                    }}
                                    style={{
                                        alignSelf: 'center',
                                        //  marginHorizontal:moderateScale(6)
                                    }}>
                                    <HMIcon name={"md-close"} style={{
                                        fontSize: moderateScale(24),
                                        color: '#f2f2f2'
                                    }}/>

                                </TouchableOpacity>
                            </View>
                            :
                            null


                    }
                    {
                        checkIndex ?
                            <View style={{width: moderateScale(6),}}/>

                            :
                            null
                    }
                    <TouchableOpacity
                        onPress={() => {

                            this.setState({
                                    indexFilter: index,
                                    typeFilter: item.type,
                                    ["dataSource" + index]: item.list ? item.list : item.places
                                },
                                () => {
                                    //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                    this.onShow('Modal')

                                })
                        }
                        }

                        style={{alignItems: 'center', flexDirection: 'row',}}
                    >

                        <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                    style={{
                                        color: checkIndex ? Colors.white : Colors.gray,
                                        //marginHorizontal: moderateScale(6),
                                        fontSize: moderateScale(13),
                                        textAlign: 'center',

                                    }}/>
                        <HMIcon name={"ios-arrow-down"} style={{
                            fontSize: moderateScale(13),
                            color: checkIndex ? '#f2f2f2' : Colors.gray,
                            marginHorizontal: moderateScale(2),
                            marginTop: moderateScale(3)
                        }}/>
                    </TouchableOpacity>


                </View>

            }
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListOperatorApplyScreen, `?type=${this.props.typee}&city=`, TypeGetListOperatorApplyScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlListOperatorApplyScreen, `?type=${this.props.typee}&Condition=`, TypeGetListOperatorApplyScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id ? data.id : data.subjectsid,
                        value: data.name ? data.name : data.subjects_tks_subject,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id ? data.id : data.subjectsid,
                value: data.name ? data.name : data.subjects_tks_subject,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {
                    id: data.id ? data.id : data.subjectsid,
                    value: data.name ? data.name : data.subjects_tks_subject,
                    type: container.state.typeFilter
                },
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;

        let resultList = childFilter.list ? childFilter.list : childFilter.places;
        const newData = resultList.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }


}
